import { useEffect, useState } from "react";
import { CheckCircle2, AlertTriangle } from "lucide-react";
import PublicHeader from "@/components/PublicHeader";
import SiteFooter from "@/components/SiteFooter";
import { useSeo } from "@/lib/seo";
import { api, ago } from "@/lib/api";

export default function Status() {
  const [s, setS] = useState(null);
  useSeo({ title: "System status", path: "/status", description: "Live operational status of JobPedestal: API, database, background workers, JobPedestal Intelligence and job sources." });
  useEffect(() => { api.get("/status").then((r) => setS(r.data)); }, []);
  return (
    <div className="min-h-screen"><PublicHeader />
      <main className="mx-auto max-w-5xl px-4 py-14 sm:px-8">
        <p className="eyebrow mb-3">Operational transparency</p>
        <h1 className="text-4xl font-extrabold" data-testid="status-title">System status</h1>
        {!s ? <p className="mt-8 text-slate-500">Checking…</p> : (
          <>
            <p className="mt-2 text-sm text-slate-500">Checked {ago(s.checked_at)} · {s.active_jobs.toLocaleString()} listings verified open</p>
            <div className="mt-8 divide-y rounded-2xl border bg-white">
              {s.components.map((c) => (
                <div key={c.name} className="flex items-center justify-between p-5" data-testid={`status-component-${c.name.split(" ")[0].toLowerCase()}`}>
                  <span className="font-medium">{c.name}</span>
                  {c.ok ? <span className="flex items-center gap-1 text-sm text-emerald-700"><CheckCircle2 className="h-4 w-4" />Operational</span> : <span className="flex items-center gap-1 text-sm text-amber-700"><AlertTriangle className="h-4 w-4" />Degraded</span>}
                </div>
              ))}
            </div>
            {s.incidents.length > 0 && <div className="mt-6 rounded-xl border border-amber-200 bg-amber-50 p-5 text-sm">{s.incidents.map((i) => <p key={i.title}><b>{i.severity}</b> · {i.title} ({i.status})</p>)}</div>}
          </>
        )}
      </main>
      <SiteFooter />
    </div>
  );
}
